var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgChecklistIcon = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61.419,
    height: 63,
    viewBox: "0 0 61.419 63",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_594",
    "data-name": "Group 594",
    transform: "translate(-109.796 -335.537)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_636",
    "data-name": "Path 636",
    d: "M161.8,378.589v15.493a2.712,2.712,0,0,1-2.826,2.582H113.622a2.712,2.712,0,0,1-2.826-2.582v-47.77a2.712,2.712,0,0,1,2.826-2.582h5.653",
    transform: "translate(0 0.872)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_637",
    "data-name": "Path 637",
    d: "M149.324,343.73h5.653c1.561,0,2.826.843,2.826,1.883v8.475",
    transform: "translate(4.465 1.524)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_638",
    "data-name": "Path 638",
    d: "M156.687,386.836v9.788H115.255l.187-42.632h2.826",
    transform: "translate(0.698 -3.43)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_639",
    "data-name": "Path 639",
    d: "M149.256,355.009h2.826l.068,10.344",
    transform: "translate(5.82 -3.841)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_640",
    "data-name": "Path 640",
    d: "M146.1,343.189h-4.238a5.652,5.652,0,0,0-11.3,0h-4.239a4.239,4.239,0,0,0-4.238,4.239v4.238h28.261v-4.238A4.239,4.239,0,0,0,146.1,343.189Z",
    transform: "translate(0.816 -1)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_32",
    "data-name": "Line 32",
    y2: 2.826,
    transform: "translate(135.646 341.776)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_641",
    "data-name": "Path 641",
    d: "M169.381,358.5a4.59,4.59,0,0,1,1.631,3.663L149.2,383.976c-3.435,3.434-8.541,3.143-8.541,3.143s-.291-5.105,3.144-8.539l21.81-21.809a4.591,4.591,0,0,1,3.664,1.631Z",
    transform: "translate(-0.824 2.541)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_33",
    "data-name": "Line 33",
    x2: 5.396,
    y2: 5.397,
    transform: "translate(162.761 361.321)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_34",
    "data-name": "Line 34",
    x2: 4.493,
    y2: 4.266,
    transform: "translate(145.667 379.037)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_35",
    "data-name": "Line 35",
    x2: 12.717,
    transform: "translate(135.149 357.102)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_642",
    "data-name": "Path 642",
    d: "M131.793,354.877l-5.652,7.065-2.269-2",
    transform: "translate(0.402 0.735)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_643",
    "data-name": "Path 643",
    d: "M131.793,354.877l-5.652,7.065-2.269-2",
    transform: "translate(0.402 11.7)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_644",
    "data-name": "Path 644",
    d: "M131.793,354.877l-5.652,7.065-2.269-2",
    transform: "translate(0.402 22.664)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_36",
    "data-name": "Line 36",
    x2: 12.717,
    transform: "translate(135.149 368.841)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_37",
    "data-name": "Line 37",
    x2: 9.891,
    transform: "translate(135.28 362.319)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_38",
    "data-name": "Line 38",
    x2: 8.478,
    transform: "translate(135.341 374.059)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgChecklistIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/checklist-icon.b1963cb1.svg";
export { ForwardRef as ReactComponent };